export default "__VITE_PUBLIC_ASSET__331ea94a__"